'use strict';

angular.module('ecrd.states')
    .component('stateInfo', {
        templateUrl: 'modules/states/components/state-info/template.html',
        controller: 'StateInfoController',
        bindings: {
            id: '<', // ID del estado
            formId: '<', // ID del formulario, si hay; si no es un estado global
            listIndices: '<', // índices del formulario
        },
    });
